import { render, staticRenderFns } from "./BetaEditor.vue?vue&type=template&id=36d97c5a&"
import script from "./BetaEditor.vue?vue&type=script&lang=js&"
export * from "./BetaEditor.vue?vue&type=script&lang=js&"
import style0 from "./BetaEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports